export const money = (n) =>
  `$${Number(n || 0).toFixed(2)}`;

export const miles = (n) =>
  n == null ? "" : `${Number(n).toFixed(1)} mi`;

export function timeAgo(ts) {
  if (!ts) return "";
  const secs = Date.now() / 1000 - ts;
  if (secs < 60) return "just now";
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
  const d = new Date(ts * 1000);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function fmtDateTime(ts) {
  if (!ts) return "";
  const d = new Date(ts * 1000);
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function fmtClock(mins) {
  const d = new Date(Date.now() + mins * 60000);
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function fmtScheduleLabel(input) {
  const d = new Date(input);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const isTomorrow = d.toDateString() === tomorrow.toDateString();
  const day = sameDay
    ? "Today"
    : isTomorrow
    ? "Tomorrow"
    : d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
  const time = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  return `${day} · ${time}`;
}

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export const cn = (...c) => c.filter(Boolean).join(" ");
